import { ContractService } from "../../../core/services/ContractService";
import { useState, useEffect } from 'react';
import { Singleton } from "../../../core/services/Singleton";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { BpmService } from "../../../core/services/BpmService";
import { AdminService } from "../../../core/services/AdminService";
import { ListMenu } from "../../theme/Component/ListMenu";
import { ActivateAccount } from "./ActivateAccount";
import { useDashboardStore } from "../../pages/hooks/useDashboardStore";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { _AccountRole, _single } from "../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_SM } from "../../theme/Component/hooks/useModal";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { encryptData } from "../../../utils/helpers";

interface PropsAdd {
    user: string;
    password: string;
}

export const AbstractAccount = () => {

    const { instance } = useDataBean(_AccountRole);
    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new BpmService();
    const serviceAdmin = new AdminService();
    const [lista, setLista] = useState([]);

    const [nit, setNit] = useState(0);
    const [name, setName] = useState('');
    const [tipoinput, setTipoinput] = useState(0);
    const [surname, setSurname] = useState('');
    const [bean, setBean] = useState<any>({});
    const { register, formState: { errors }, handleSubmit } = useForm();
    const [modalEditar, setModalEditar] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [account, setAccount] = useState<PropsAdd>({
        password: "",
        user: "",
    });

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal1, setModal1] = useState<any>({ name: 'Cuenta de Usuario', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modalDelete = useModal("Eliminar cuenta de usuario", MODAL_SM);

    const getListaBN = () => {
        setLoading(true);
        service.getAccountByNit(nit).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setLoading(false);
            }
        );
    }
    const getListaBN2 = (cc: any) => {
        setLoading(true);
        service.getAccountByNit(cc).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    let temp = resp.DataBeanProperties.ObjectValue;
                    if (temp.length > 0) {
                        setBean(temp[0].DataBeanProperties);
                    }
                }
                setLoading(false);
            }
        );
    }

    const getListaS = () => {
        setLoading(true);
        service.getAccount(null, surname).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setLoading(false);
            }
        );
    }

    const getListaN = () => {
        setLoading(true);
        service.getAccount(name, null).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                setLoading(false);
            }
        );
    }

    const agregarItem = () => {

        let b = {
            Nit: null,
            Name1: '',
            Name2: '',
            Surname1: '',
            Surname2: '',
            Tel: '',
            eMail: '',
        }
        setBean(b);
        setModal({ ...modal, ['view']: true });
    }

    const updateItem = () => {
        setModal({ ...modal, "view": false });
        if (bean.IDAccount) {
            setLoading(true);
            service.updateAbstractAccount(bean).subscribe(
                (resp: any) => {
                    setLoading(false);
                    if (resp.DataBeanProperties.ObjectValue) {
                        getListaS();
                        getListaN();
                        getListaBN();
                    }
                });
        } else {
            setLoading(true);
            service.createAccount(bean).subscribe(
                (resp: any) => {
                    setLoading(false);
                    if (resp.DataBeanProperties.ObjectValue) {
                        getListaS();
                        getListaN();
                        getListaBN();
                    }
                });
        }
    }

    const Crearcuenta = () => {
        setLoading(true);
        service.createSupplier(bean.Nit, single.getAccountID(), bean).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ObjectValue) {
                    let tmp = resp.DataBeanProperties.ObjectValue;
                    setLista(tmp);
                    toast.success('Se ha creado la cuenta')
                }
                setModalEditar({ ...modalEditar, "view": false });
                setLoading(false);
            }
        );
    }

    const head = [
        { title: 'ID', property: "IDAccount" },
        { title: 'Cédula/Nit', property: 'Nit' },
        { title: 'Nombre', property: 'EntityName' },
        { title: 'Correo', property: 'eMail' },
        { title: 'Teléfono', property: 'Tel' },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
            { titulo: 'Activar cuenta', icono: 'ri-file-user-line', visible: true, evento: () => { setModal1({ ...modal1, "view": true }) } },
            { titulo: 'Desactivar Cuenta', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const activateUser = () => {
        instance.activateUserAccountLocal(bean.IDAccount, encryptData(account.user), encryptData(account.password)).then(
            (resp) => {
                toast.success("Usuario Actviado")
                setModal1({ ...modal1, view: false });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const cancelUserAccount = () => {
        instance.desactivateUserAccount(bean.IDAccount).then(
            (resp) => {
                toast.success("Usuario Desactivado");
                modalDelete.close();
            }
        ).catch(err => { toast.error(err) })
    }

    const [showPassword, setShowPassword] = useState(false);

    return (
        <>
            <BasicPage titulo="Gestión de Usuarios">
                <div className="row">
                    <div className="col-md-4">
                        <label>Filtrar por:</label>
                        <select className="form-control" value={tipoinput} onChange={(e: any) => { setTipoinput(e.target.value) }}>
                            <option value={0}>...</option>
                            <option value={1}>Identificación</option>
                            <option value={2}>Nombres</option>
                            <option value={3}>Apellidos</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        {tipoinput == 3 &&
                            <>
                                <label>Buscar</label>
                                <input type="text" onChange={(e: any) => setSurname(e.target.value)} className="form-control inputSurname " placeholder="Filtrar pór Apellido" />
                            </>

                        }
                        {tipoinput == 2 &&
                            <>
                                <label>Buscar</label>
                                <input type="text" onChange={(e: any) => setName(e.target.value)} className="form-control inputName " placeholder="Filtrar por Nombre" />
                            </>

                        }
                        {tipoinput == 1 &&
                            <>
                                <label>Buscar</label>
                                <input type="text" onChange={(e: any) => setNit(e.target.value)} className="form-control inputNit " placeholder="Filtrar por Cedula / Nit" />
                            </>

                        }
                    </div>

                    <div className="col-md-4 mt-4">

                        {tipoinput == 3 &&

                            <BasicButton value="BUSCAR" icon="ri-file-add-line" eventClick={getListaS} ></BasicButton>

                        }
                        {tipoinput == 2 &&
                            <>

                                <BasicButton value="BUSCAR" icon="ri-file-add-line" eventClick={getListaN} ></BasicButton>
                            </>}
                        {tipoinput == 1 &&
                            <>

                                <BasicButton value="BUSCAR" icon="ri-file-add-line" eventClick={getListaBN} ></BasicButton>
                            </>}
                    </div>



                </div>
                <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setBean} />
            </BasicPage>

            <Modal modal={modal1} updateModal={setModal1} eventModal={() => { activateUser() }} >
                <div className="row">
                    <div className="col-md-12">
                        <label>Usuario</label>
                        <input type="text" className="form-control" value={account.user} onChange={((e) => { setAccount({ ...account, user: e.target.value }) })} />
                    </div>
                    <div className="col-md-12">
                        <label>Contraseña</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                value={account.password}
                                onChange={(e) => setAccount({ ...account, password: e.target.value })}
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword((prev) => !prev)}
                            >
                                {showPassword ? "Ocultar" : "Ver"}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-12">
                        <label className="form-label">No. Identificación *</label>
                        <input type="text" className="form-control" value={bean.Nit} onBlur={(e) => {
                            //console.log("Valor cambiado ", e.target.value);
                            getListaBN2(e.target.value);
                        }} onChange={(e) => {
                            setBean({ ...bean, ['Nit']: e.target.value })
                        }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Primer Nombre *</label>
                        <input type="text" className="form-control" value={bean.Name1} onChange={(e) => { setBean({ ...bean, ['Name1']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Segundo Nombre </label>
                        <input type="text" className="form-control" value={bean.Name2} onChange={(e) => { setBean({ ...bean, ['Name2']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Primer Apellido *</label>
                        <input type="text" className="form-control" value={bean.Surname1} onChange={(e) => { setBean({ ...bean, ['Surname1']: e.target.value }) }} />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Segundo Apellido *</label>
                        <input type="text" className="form-control" value={bean.Surname2} onChange={(e) => { setBean({ ...bean, ['Surname2']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Celular *</label>
                        <input type="text" className="form-control" value={bean.Tel} onChange={(e) => { setBean({ ...bean, ['Tel']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Correo Electronico *</label>
                        <input type="text" className="form-control" value={bean.eMail} onChange={(e) => { setBean({ ...bean, ['eMail']: e.target.value }) }} />
                    </div>

                </div>
            </Modal>

            <Modal modal={modalEditar} updateModal={setModalEditar} eventModal={Crearcuenta} >
                <div className="row">
                    <div className="col-md-12"> <h6>Por favor complete la información del formulario.</h6></div>

                </div>


                <div className="row">
                    <div className="col-md-12">
                        <div className="group">
                            <label>Nombre de la Empresa</label>
                            <input type="text" className="input-color form-control" value={bean.Name} {...register('empresanombre', { required: true, maxLength: 20 })} onChange={(e) => { setBean({ ...bean, ['Name']: e.target.value }) }} />

                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="group">
                            <label>Dirección</label>
                            <input type="text" className="input-color form-control" value={bean.Address} onChange={(e) => { setBean({ ...bean, ['Address']: e.target.value }) }} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="group">
                            <label>Teléfono</label>
                            <input type="number" className="input-color form-control" value={bean.Tel} onChange={(e) => { setBean({ ...bean, ['Tel']: e.target.value }) }} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="group">
                            <label>Correo eléctronico</label>
                            <input type="text" className="input-color form-control" value={bean.eMail} onChange={(e) => { setBean({ ...bean, ['eMail']: e.target.value }) }} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="group">
                            <label>Nombre de representante legal</label>
                            <input type="text" className="input-color form-control" value={bean.NameLegalRep} onChange={(e) => { setBean({ ...bean, ['NameLegalRep']: e.target.value }) }} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="group">
                            <label>Nombre de contacto</label>
                            <input type="text" className="input-color form-control" value={bean.ContactName} onChange={(e) => { setBean({ ...bean, ['ContactName']: e.target.value }) }} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="group">
                            <label>Página web</label>
                            <input type="text" className="input-color form-control" value={bean.WebPage} onChange={(e) => { setBean({ ...bean, ['WebPage']: e.target.value }) }} />
                        </div>
                    </div>

                </div>
            </Modal>
            <Modal modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={cancelUserAccount} onSubmitLabel="Eliminar">
                <p>Eliminar cuenta de usuario ? </p>
            </Modal>
        </>
    )
}

